import type { I18n } from '@lingui/core';
import { formatNumber } from './format';

export const formatFileSize = (locale: I18n | string, bytes: number): string => {
  if (bytes < 1024) return `${formatNumber(locale, bytes)} B`;
  const options = { minimumFractionDigits: 1, maximumFractionDigits: 1 };
  if (bytes < 1024 * 1024) return `${formatNumber(locale, bytes / 1024, options)} KB`;
  return `${formatNumber(locale, bytes / (1024 * 1024), options)} MB`;
};
